module.exports = __webpack_public_path__ + "static/media/dollar_coins.5bf49e79.svg";